import type { Timestamp } from 'firebase/firestore';

type HoldExpiryField = Timestamp | { seconds: number; nanoseconds?: number };

export function getHoldExpiresAtMs(expiresAt: HoldExpiryField): number | null {
  if (expiresAt && typeof (expiresAt as Timestamp).toMillis === 'function') {
    return (expiresAt as Timestamp).toMillis();
  }

  if (typeof (expiresAt as { seconds?: number }).seconds === 'number') {
    const { seconds, nanoseconds = 0 } = expiresAt as { seconds: number; nanoseconds?: number };
    return seconds * 1000 + Math.floor(nanoseconds / 1e6);
  }

  return null;
}

export function isActiveHold(
  hold: { status: string; expiresAt: HoldExpiryField },
  nowMs = Date.now(),
): boolean {
  const expiresMs = getHoldExpiresAtMs(hold.expiresAt);
  if (expiresMs === null) {
    return false;
  }

  return hold.status === 'active' && expiresMs > nowMs;
}

export function pruneExpiredHolds<T extends { status: string; expiresAt: HoldExpiryField }>(
  holds: T[],
  nowMs = Date.now(),
): T[] {
  return holds.filter((hold) => isActiveHold(hold, nowMs));
}
